export default "__VITE_PUBLIC_ASSET__a1f74dc8__"